import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { ViewTitle } from '../components/reusable'
import { HomeView } from '../components/views/homeView'

function Home() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <ViewTitle text="Dashboard" />
                <HomeView />
            </MainView>
        </div>
    )
}

export default Home
